'use strict';
$(document).ready(function () {
    //verse 2
    const initModel = $('input[id="initModel"]').val();
    var models = [];
    $(".reservation-swiper .swiper-slide").each(function (i) {
        models.push($(this).data("model"));
    });

    var initialSlide = $('.reservation-swiper .swiper-slide[data-model="'+initModel+'"]').index('.reservation-swiper .swiper-slide');
    initialSlide = initialSlide !== -1 ? initialSlide : 0;

    var slidesPerView = $(window).width() > 1920 ? 3 : 2.3;

    var swiper = new Swiper(".reservation-swiper", {
            spaceBetween: 1,
            slidesPerView: slidesPerView,
            centeredSlides: true,
            roundLengths: true,
            loop: true,
            loopAdditionalSlides: 30,
            speed: 500,
            initialSlide: initialSlide,
            maxBackfaceHiddenSlides: 4,
            updateOnImagesReady: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<div class="' + className + '" data-model="' + models[index] + '"><span></span></div>';
                }
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    centeredSlides: true
                },
                769: {
                    slidesPerView: 1.7,
                    centeredSlides: true
                },
                900: {
                    slidesPerView: 2.2,
                    centeredSlides: true
                },
                1921: {
                    slidesPerView: slidesPerView,
                }
            }
        }
    );
    var featuresSwiper = new Swiper('.features-slider', {
        speed: 500,
        effect: 'fade',
        loop: true,
        loopAdditionalSlides: 30,
        centeredSlides: true,
        roundLengths: true,
        initialSlide: initialSlide,
        allowTouchMove: false
    });
    swiper.controller.control = featuresSwiper;
    $('.swiper-button-next-fake').click(function () {
        $('.swiper-pagination-bullet:first-child').click();
    })
    var modelActive = $('.reservation-swiper .swiper-slide-active');
    swiper.on('slideChangeTransitionStart', function () {
        modelActive = $('.reservation-swiper .swiper-slide-active');
        var modelSelected = modelActive.data('model');
        selectedModel(modelSelected);
        selectedModelSpec(modelSelected);
        selectedModelVehicleDisclaimers(modelSelected);
    })
    var elmentHeight = $('#productDesItem0').height();
    var highestHeight = 0;
    var currentEl;
    var productDesContainer;

    function initProductDes() {
        if ($(window).width() <= 768) {
            productDesContainer = $('.productdes.mobile');
            $('.productdes.desktop').addClass('d-none');
            $('.productdes.mobile').removeClass('d-none');
        } else {
            productDesContainer = $('.productdes.desktop');
            $('.productdes.mobile').addClass('d-none');
            $('.productdes.desktop').removeClass('d-none');
        }
        highestHeight = 0;
        productDesContainer.find('.product-des').each(function (index, item) {
            if ($(item).height() > highestHeight) {
                highestHeight = $(item).height()
            }
        })
        $('.product-des').css('margin-bottom', '0');
        productDesContainer.css('height', highestHeight);
    }

    initProductDes();
    $(window).on('resize', function () {
        initProductDes();
        selectedModel(modelActive.data('model'));
    });

    function selectedModel(idModel) {
        $('.modal-spec').slideUp();
        $('.hide').addClass('d-none');
        if (idModel === 'VF8' || idModel === 'VF9') {
            $('.show-more').addClass('d-none');
        } else {
            $('.show-more').addClass('d-none');
        }
        $('.product-des').css('margin', 0);
        selectedModelButton(idModel);

        switch (idModel) {
            case 'VF6':
                elmentHeight = 0;
                currentEl = productDesContainer.find('#productDesItem0');
                // $('.price-container').css('top' , '0px');
                break;
            case 'VF7':
                elmentHeight = productDesContainer.find('#productDesItem0').height();
                currentEl = productDesContainer.find('#productDesItem1');
                // $('.price-container').css('top' , '-'+_height+'px');
                break;
            case 'VF8':
                elmentHeight = productDesContainer.find('#productDesItem0').height() + productDesContainer.find('#productDesItem1').height();
                currentEl = productDesContainer.find('#productDesItem2');
                // $('.price-container').css('top' , '-'+_height*2+'px');
                break;
            case 'VF9':
                elmentHeight = productDesContainer.find('#productDesItem0').height() + productDesContainer.find('#productDesItem1').height() + productDesContainer.find('#productDesItem2').height();
                currentEl = productDesContainer.find('#productDesItem3');
                // $('.price-container').css('top' , '-'+_height*3+'px');
                break;
            default:
                break;
        }
        if (currentEl.height() < highestHeight) {
            currentEl.css('margin-bottom', (highestHeight - currentEl.height()) + 'px');
        }
        $('.productdes-container').css('top', '-' + elmentHeight + 'px');
    }

    function selectedModelSpec(idModel) {
        $('.reserve').not('.reserve-model-' + idModel).addClass('d-none');
        if (idModel === 'VF8') {
            $('#vf8-an-de-recharge-offert').addClass('d-block');
        } else {
            $('#vf8-an-de-recharge-offert').removeClass('d-block');
        }
        $('.product-info').addClass('d-none');
        $('.reserve-model-' + idModel).removeClass('d-none');
        var selectModelSpec = $('.model-spec-' + idModel);
        $('.model-spec-item').removeClass('active');
        if (selectModelSpec.length) {
            selectModelSpec.addClass('active');
        }
    }

    function selectedModelVehicleDisclaimers(idModel) {
        var selectModelSpec = $('.vehicle-disclaimers-' + idModel);
        $('.vehicle-disclaimers-item').removeClass('active');
        if (selectModelSpec.length) {
            selectModelSpec.addClass('active');
        }
    }

    function selectedModelButton(idModel) {
        var productName = $('.reservation-swiper .swiper-slide[data-model="' + idModel + '"]').attr('data-name');
        $('.reserve .reserve-model-label').html(productName);
    }

    $('.show-more').on('click', function () {
        var modelSelected = modelActive.data('model');
        $('.modal-spec-' + modelSelected).slideDown();
        $(this).addClass('d-none');
        $('.hide').removeClass('d-none');
    })
    $('.hide').on('click', function () {
        var modelSelected = modelActive.data('model');
        $('.modal-spec-' + modelSelected).slideUp();
        $(this).addClass('d-none');
        $('.show-more').removeClass('d-none');
    })
    $('.product-info .reserve').on('click', function () {
        var url = $("#addCart").val();
        var productID = modelActive.data('id');
        if (modelActive.data('url') !== '' && !$(this).hasClass('reserve-now')) {
            location.href =  modelActive.data('url');
            return;
        }
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: {pid: productID, quantity: "1"},
            success: function (data) {
                document.getElementById("reservecheckout-continueguest").click();
            },
            error: function (err) {
            }
        });
    })

    // Collapse Block FAQ
    $('.main-content > li > .spec-detail-content').hide();
    $('.main-content > li').click(function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active").find(".spec-detail-content").slideUp();
        } else {
            $(".main-content > li.active .spec-detail-content").slideUp();
            $(".main-content > li.active").removeClass("active");
            $(this).addClass("active").find(".spec-detail-content").slideDown({
                start: function () {
                    $(this).css({
                        display: "flex"
                    });
                }
            });
        }
    });

    $('.reservation-container sup').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".section-term").offset().top
        }, 300);
    });
});
